'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var reactIntl = require('react-intl');
var utils = require('./utils.js');

var FormatAppointmentTime = function (props) {
    var startTime = props.startTime, endTime = props.endTime, className = props.className, _a = props.compact, compact = _a === void 0 ? false : _a;
    var _b = reactIntl.useIntl(), fm = _b.formatMessage, fdt = _b.formatDateToParts, ft = _b.formatTime, fd = _b.formatDate;
    return (React__default.createElement(core.Typography, { className: className, variant: 'body1' },
        !compact && utils.formatAppointmentTime(fm, fdt, startTime, endTime),
        compact && utils.formatAppointmentTimeCompact(fm, fd, ft, startTime)));
};

module.exports = FormatAppointmentTime;
